import React from "react";
import { Container, Box, Typography, Card, CardContent } from "@mui/material";
import { skills } from "../data/skills";
const Skills: React.FC = () => {
  const getLevelLabel = (level: number): string => {
    if (level >= 85) return "Expert";
    if (level >= 65) return "Proficient";
    return "Familiar";
  };
  const getFilledDots = (level: number): number => {
    return Math.ceil(level / 20);
  };
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {" "}
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, mb: 4, textAlign: "center" }}
      >
        {" "}
        Toolbox{" "}
      </Typography>{" "}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(4, 1fr)",
            md: "repeat(6, 1fr)",
          },
          gap: 2,
        }}
      >
        {" "}
        {skills.map((skill, index) => (
          <Card
            key={index}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": { transform: "translateY(-4px)", boxShadow: 3 },
            }}
          >
            {" "}
            <CardContent
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                p: 2,
              }}
            >
              {" "}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 1.5,
                }}
              >
                {" "}
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  {" "}
                  {[...Array(5)].map((_, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor:
                          idx < getFilledDots(skill.level)
                            ? "primary.main"
                            : "rgba(145, 189, 58, 0.2)",
                      }}
                    />
                  ))}{" "}
                </Box>{" "}
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.65rem",
                    color: "text.secondary",
                    fontWeight: 500,
                  }}
                >
                  {" "}
                  {getLevelLabel(skill.level)}{" "}
                </Typography>{" "}
              </Box>{" "}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                  flexGrow: 1,
                  justifyContent: "center",
                }}
              >
                {" "}
                {skill.icon && (
                  <Box
                    component="img"
                    src={skill.icon}
                    alt={skill.name}
                    sx={{
                      width: 32,
                      height: 32,
                      objectFit: "contain",
                      display: skill.icon ? "block" : "none",
                    }}
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = "none";
                    }}
                  />
                )}{" "}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    textAlign: "center",
                    fontSize: "0.875rem",
                  }}
                >
                  {" "}
                  {skill.name}{" "}
                </Typography>{" "}
              </Box>{" "}
            </CardContent>{" "}
          </Card>
        ))}{" "}
      </Box>{" "}
    </Container>
  );
};
export default Skills;
